import {assert} from 'Asserts';

import {SimpleRule, SimpleRuleInput} from './types';

export function getInputForSimpleRule(
  simpleRules: Array<SimpleRule>,
  validationRuleTemplateId: string,
  inputKey: string
): SimpleRuleInput | null {
  const simpleRule = simpleRules.find((rule) => rule.validationRuleTemplateId === validationRuleTemplateId);
  if (!simpleRule) {
    return null;
  }
  assert(
    simpleRule.constantInputs.hasOwnProperty(inputKey),
    `Input key '${inputKey}' not found in simple rule.`
  );
  return simpleRule.constantInputs[inputKey];
}

export function doesSimpleRuleExist(
  simpleRules: Array<SimpleRule>,
  validationRuleTemplateId: string
): boolean {
  const simpleRule = simpleRules.find((rule) => rule.validationRuleTemplateId === validationRuleTemplateId);
  return simpleRule != null;
}

export const validationRuleTemplateIdToDisplayName: Record<string, string> = {
  // boolean rules
  svdrltmpl_booleanfieldequals: 'Must equal',

  // integer rules
  svdrltmpl_integerfielddisallowedvalue: 'Cannot equal',
  svdrltmpl_integerfieldminvalue: 'Min value',
  svdrltmpl_integerfieldmaxvalue: 'Max value',

  // float rules
  svdrltmpl_floatfielddisallowedvalue: 'Cannot equal',
  svdrltmpl_floatfieldminvalue: 'Min value',
  svdrltmpl_floatfieldmaxvalue: 'Max value',

  // text rules
  svdrltmpl_textfieldnotequals: 'Cannot equal',
  svdrltmpl_textfieldcontains: 'Contains',
  svdrltmpl_textfieldnotcontains: "Doesn't contain",
};
